import { apiClient } from '@borradh-workspace/api-client';
import {
  type PublicSiteView,
  publicSiteViewSchema,
} from '@borradh-workspace/contracts';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import {
  type SiteDomainIntent,
  buildSiteDomainPayload,
} from './site-domain-update.payload';
export function useSiteDomainUpdate(
  locationId: string,
  callbacks: {
    onSuccess: (site: PublicSiteView) => void;
    onError: (error: Error) => void;
  }
) {
  const mutation = useMutation({
    mutationFn: (intent: SiteDomainIntent) =>
      apiClient.post<PublicSiteView>(
        `public-sites/${encodeURIComponent(locationId)}/domain/${intent.action}`,
        buildSiteDomainPayload(intent),
        { schema: publicSiteViewSchema }
      ),
    ...callbacks,
  });
  const { mutate } = mutation;
  const connect = useCallback(
    (hostname: string) => mutate({ action: 'connect', hostname }),
    [mutate]
  );
  const check = useCallback(() => mutate({ action: 'check' }), [mutate]);
  const disconnect = useCallback(
    () => mutate({ action: 'disconnect' }),
    [mutate]
  );
  return { ...mutation, connect, check, disconnect };
}
